/* Lihongjade theme JS: mobile nav, hero slider, PDP gallery */
document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav
  var toggle = document.querySelector('.mobile-nav-toggle');
  var nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    var setNav = function (open) {
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('nav-open', open);
      toggle.setAttribute('aria-expanded', open);
    };
    toggle.addEventListener('click', function () { setNav(!nav.classList.contains('is-open')); });
    var closeBtn = nav.querySelector('.mobile-nav-close');
    if (closeBtn) closeBtn.addEventListener('click', function () { setNav(false); });
    nav.querySelectorAll('.main-nav__item--has-children > a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.innerWidth <= 991) {
          e.preventDefault();
          link.parentElement.classList.toggle('is-expanded');
        }
      });
    });
  }

  // Hero slider
  document.querySelectorAll('.hero').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dots button');
    var prev = hero.querySelector('.hero__arrow--prev');
    var next = hero.querySelector('.hero__arrow--next');
    if (slides.length < 2) return;
    var idx = 0, timer, animating = false;
    // Desktop keeps the 1.8s crossfade; mobile slides horizontally to match the swipe gesture.
    function show(i, dir) {
      var from = idx, to = (i + slides.length) % slides.length;
      if (to === from || animating) return;
      dir = dir || 1;
      if (dots[from]) dots[from].classList.remove('is-active');
      if (dots[to]) dots[to].classList.add('is-active');
      if (window.innerWidth <= 767) {
        animating = true;
        var out = slides[from], inn = slides[to];
        inn.style.transition = 'none';
        inn.style.opacity = '1';
        inn.style.transform = 'translateX(' + (dir > 0 ? 100 : -100) + '%)';
        inn.classList.add('is-active');
        void inn.offsetWidth;
        inn.style.transition = 'transform .35s ease, opacity 0s';
        out.style.transition = 'transform .35s ease, opacity 0s';
        out.style.opacity = '1';
        inn.style.transform = 'translateX(0)';
        out.style.transform = 'translateX(' + (dir > 0 ? -100 : 100) + '%)';
        setTimeout(function () {
          out.classList.remove('is-active');
          [out, inn].forEach(function (s) { s.style.transition = s.style.transform = s.style.opacity = ''; });
          animating = false;
        }, 380);
      } else {
        slides[from].classList.remove('is-active');
        slides[to].classList.add('is-active');
      }
      idx = to;
    }
    function auto() { timer = setInterval(function () { show(idx + 1, 1); }, 5000); }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { clearInterval(timer); show(i, i > idx ? 1 : -1); auto(); });
    });
    if (prev) prev.addEventListener('click', function () { clearInterval(timer); show(idx - 1, -1); auto(); });
    if (next) next.addEventListener('click', function () { clearInterval(timer); show(idx + 1, 1); auto(); });
    // Mobile: thumb-swipe between slides (arrows are hidden under 768px)
    var startX = null;
    hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { clearInterval(timer); show(idx + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); auto(); }
      startX = null;
    }, { passive: true });
    auto();
  });

  // PDP gallery: thumb strip + prev/next arrows; directional slide transition (fotorama-style)
  var mainImg = document.querySelector('.product-gallery__main img');
  var mainWrap = document.querySelector('.product-gallery__main');
  var thumbs = [].slice.call(document.querySelectorAll('.product-gallery__thumbs img'));
  var current = 0;
  var sliding = false;
  function showImage(i, dir) {
    if (!mainImg || !thumbs.length || sliding) return;
    var target = (i + thumbs.length) % thumbs.length;
    if (dir === undefined) dir = target === current ? 0 : (target > current ? 1 : -1);
    current = target;
    var t = thumbs[current];
    var next = t.dataset.full || t.src;
    thumbs.forEach(function (a) { a.classList.remove('is-active'); });
    t.classList.add('is-active');
    if (t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    if (mainImg.src === next) return;
    sliding = true;
    var pre = new Image();
    var go = function () {
      var incoming = document.createElement('img');
      incoming.src = next;
      incoming.alt = mainImg.alt;
      incoming.style.cssText = 'position:absolute;inset:0;width:100%;z-index:2;border-radius:4px;' +
        'transform:translateX(' + (dir < 0 ? '-100%' : '100%') + ');transition:transform .4s ease;';
      mainWrap.appendChild(incoming);
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        incoming.style.transform = 'translateX(0)';
        mainImg.style.transition = 'transform .4s ease';
        mainImg.style.transform = 'translateX(' + (dir < 0 ? '100%' : '-100%') + ')';
      }); });
      setTimeout(function () {
        mainImg.src = next;
        mainImg.style.transition = 'none';
        mainImg.style.transform = '';
        incoming.remove();
        void mainImg.offsetWidth;
        mainImg.style.transition = '';
        sliding = false;
      }, 430);
    };
    pre.onload = go;
    pre.onerror = go;
    pre.src = next;
  }
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { showImage(i); });
  });
  // Warm the full-size images once the page settles, so thumb taps swap instantly
  // (showImage preloads before animating — a cold CDN fetch per tap reads as lag)
  if (thumbs.length) {
    var warmGallery = function () {
      thumbs.forEach(function (t) { var im = new Image(); im.src = t.dataset.full || t.src; });
    };
    if ('requestIdleCallback' in window) { requestIdleCallback(warmGallery, { timeout: 3000 }); }
    else { setTimeout(warmGallery, 1200); }
  }
  // Mobile: swipe the main image (gallery arrows are hidden under 768px)
  if (mainWrap) {
    var galleryStartX = null;
    mainWrap.addEventListener('touchstart', function (e) { galleryStartX = e.touches[0].clientX; }, { passive: true });
    mainWrap.addEventListener('touchend', function (e) {
      if (galleryStartX === null) return;
      var dx = e.changedTouches[0].clientX - galleryStartX;
      if (Math.abs(dx) > 40) { showImage(current + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); }
      galleryStartX = null;
    }, { passive: true });
  }
  var prevBtn = document.querySelector('.gallery-arrow--prev');
  var nextBtn = document.querySelector('.gallery-arrow--next');
  if (prevBtn) prevBtn.addEventListener('click', function () { showImage(current - 1, -1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showImage(current + 1, 1); });
  // thumb strip edge arrows: scroll the strip by three thumbs
  var strip = document.querySelector('.product-gallery__thumbs');
  var tPrev = document.querySelector('.thumb-arrow--prev');
  var tNext = document.querySelector('.thumb-arrow--next');
  if (strip && tPrev) tPrev.addEventListener('click', function () { strip.scrollBy({ left: -300, behavior: 'smooth' }); });
  if (strip && tNext) tNext.addEventListener('click', function () { strip.scrollBy({ left: 300, behavior: 'smooth' }); });
});

/* Mobile footer accordion (port of Magento footer block toggles) */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.footer-acc-title').forEach(function (t) {
    t.addEventListener('click', function () {
      if (window.innerWidth > 767) return;
      t.parentElement.classList.toggle('active');
    });
  });
});
/* SEO accordion + FAQ tab accordions (port of live behavior) */
document.addEventListener('DOMContentLoaded', function () {
  var seo = document.querySelector('.seo-acc');
  if (seo) {
    var toggle = seo.querySelector('.seo-acc__toggle');
    var flip = function () {
      seo.classList.toggle('open');
      toggle.textContent = seo.classList.contains('open') ? '[-]' : '[+]';
    };
    seo.querySelector('.seo-acc__title').addEventListener('click', flip);
  }
  document.querySelectorAll('.rte .tabtitle').forEach(function (t) {
    t.addEventListener('click', function () { t.classList.toggle('active'); });
  });
});/* Collection toolbar: sort/show navigation.
   Built without the URL constructor — a storefront script clobbers window.URL. */
document.addEventListener('DOMContentLoaded', function () {
  function setParams(changes) {
    var parts = location.search.replace(/^\?/, '').split('&').filter(Boolean);
    var out = [];
    for (var i = 0; i < parts.length; i++) {
      var k = decodeURIComponent(parts[i].split('=')[0]);
      if (k === 'page' || Object.prototype.hasOwnProperty.call(changes, k)) continue;
      out.push(parts[i]);
    }
    for (var key in changes) {
      if (changes[key] !== null) out.push(key + '=' + encodeURIComponent(changes[key]));
    }
    location.href = location.pathname + (out.length ? '?' + out.join('&') : '');
  }
  var sortSel = document.getElementById('SortBy');
  if (sortSel) sortSel.addEventListener('change', function () { setParams({ sort_by: this.value }); });
  var arrow = document.querySelector('.sorter-arrow');
  if (arrow) arrow.addEventListener('click', function (e) {
    e.preventDefault();
    setParams({ sort_by: arrow.getAttribute('data-sort') });
  });
  document.querySelectorAll('.show-per-page').forEach(function (sel) {
    sel.addEventListener('change', function () {
      setParams({ view: sel.value === '16' ? null : 'show' + sel.value });
    });
  });
});
/* Mobile: card overlay appears on first tap, second tap acts (Magento mobile behavior).
   Until the card is tapped the overlay has pointer-events:none, so a first tap can never
   land on BUY NOW/ASK; once tapped, those spans' own handlers take the click. */
document.addEventListener('click', function (e) {
  if (window.innerWidth > 767) return;
  var open = document.querySelectorAll('.product-card.is-tapped');
  var media = e.target.closest('.product-card__media');
  if (!media) {
    open.forEach(function (c) { c.classList.remove('is-tapped'); });
    return;
  }
  var card = media.closest('.product-card');
  if (!card.classList.contains('is-tapped')) {
    e.preventDefault();
    open.forEach(function (c) { c.classList.remove('is-tapped'); });
    card.classList.add('is-tapped');
  }
});
/* Collection card BY APPOINTMENT: open WhatsApp consult (live parity), not a PDP link */
document.addEventListener('click', function (e) {
  var wa = e.target.closest('.product-card__tocart[data-wa-url]');
  if (!wa) return;
  e.preventDefault();
  e.stopPropagation();
  window.open(wa.getAttribute('data-wa-url'), '_blank', 'noopener');
});
/* Collection card BUY NOW: add to cart directly (live parity), not a PDP link */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.product-card__tocart[data-variant-id]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  btn.textContent = 'ADDING…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }),
  }).then(function (r) {
    if (!r.ok) throw new Error('add failed');
    window.location.href = '/cart';
  }).catch(function () {
    btn.textContent = 'BUY NOW';
  });
});
